import tryCreateDataURIFromImage from './tryCreateDataURIFromImage';
import datapoints from '../datapoints';
import inlineImageStore from '../store/store';
import { logUsage } from 'owa-analytics';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
var CONTENT_TYPE_ATTRIBUTE_NAME = 'contenttype';
var FIREFOX_BROWSER_NAME = 'firefox';
var GIF_CONTENT_TYPE_NAME = 'gif';
var IMAGE_TAG_NAME = 'img';
var ORIGINAL_SRC_ATTRIBUTE_NAME = 'originalsrc';
var RESTORE_IMAGE_CALLBACK_TIMEOUT_LENGTH = 500;
var SOURCE_ATTRIBUTE_NAME = 'src';
var USER_SELECT_ALL_VALUE = 'all';
var USER_SELECT_NONE_VALUE = 'none';
var ImageCopyHandler = /** @class */ (function () {
    function ImageCopyHandler() {
        var _this = this;
        this.restoreImageAttributes = function () {
            if (_this.imagesToRestore) {
                var imageToRestore = _this.imagesToRestore.pop();
                while (imageToRestore) {
                    var image = imageToRestore.image, sourceToRestore = imageToRestore.sourceToRestore, shouldSetUserSelectNone = imageToRestore.shouldSetUserSelectNone;
                    if (sourceToRestore) {
                        image.src = sourceToRestore;
                    }
                    if (shouldSetUserSelectNone) {
                        image.style.webkitUserSelect = USER_SELECT_NONE_VALUE;
                    }
                    imageToRestore = _this.imagesToRestore.pop();
                }
            }
        };
        this.imagesToRestore = [];
    }
    ImageCopyHandler.prototype.dispose = function () {
        this.imagesToRestore = null;
    };
    ImageCopyHandler.prototype.handleCopy = function (target) {
        var images = target.getElementsByTagName(IMAGE_TAG_NAME);
        // Iterate over the array of images and try to create dataURIs for those that have attachment download links for their source.
        // If we're able to create one, replace the src on the image so pasting elsewhere will render correctly.
        var length = images.length;
        var isFirefox = navigator.userAgent.toLowerCase().indexOf(FIREFOX_BROWSER_NAME) > -1;
        // Attachment code has logic to fall back to the window's origin. Check both URLs.
        var downloadUrlBase = getUserConfiguration().ApplicationSettings.DownloadUrlBase;
        var fallbackURL = window.location.origin;
        for (var idx = 0; idx < length; idx++) {
            var image = images[idx];
            var imageSrc = image.getAttribute(SOURCE_ATTRIBUTE_NAME);
            if (imageSrc &&
                (imageSrc.indexOf(downloadUrlBase) == 0 || imageSrc.indexOf(fallbackURL) == 0)) {
                var originalSrc = image.getAttribute(ORIGINAL_SRC_ATTRIBUTE_NAME);
                // First try to get the dataURI from the store, if we don't have it, try to create one now.
                var dataURI = inlineImageStore.inlineImages[originalSrc];
                if (!dataURI) {
                    dataURI = tryCreateDataURIFromImage(image);
                }
                if (dataURI) {
                    var gifSource = null;
                    var shouldSetUserSelectNone = false;
                    var contentType = image.getAttribute(CONTENT_TYPE_ATTRIBUTE_NAME);
                    if (contentType && contentType.indexOf(GIF_CONTENT_TYPE_NAME) != -1) {
                        // If this image is a gif, assume it's animated and save its src to restore later.
                        // Note: Currently, contenttype is only stamped on the image for compose. Copying gifs from the reading pane will not be detected.
                        // This results in the gif animation stopping until the next time it is loaded.
                        gifSource = imageSrc;
                    }
                    if (isFirefox && image.style.webkitUserSelect == USER_SELECT_NONE_VALUE) {
                        // If this is firefox and the image has userSelect = 'none', we need to temporarily replace it with 'all' to actually copy the image.
                        image.style.webkitUserSelect = USER_SELECT_ALL_VALUE;
                        shouldSetUserSelectNone = true;
                    }
                    if (gifSource || shouldSetUserSelectNone) {
                        this.imagesToRestore.push({
                            image: image,
                            sourceToRestore: gifSource,
                            shouldSetUserSelectNone: shouldSetUserSelectNone,
                        });
                    }
                    image.src = dataURI;
                }
                else {
                    // If the dataURI is still null at this point, log this occurrence.
                    logUsage(datapoints.ImageCopyHandlerNullDataURI.datapoint.name);
                }
            }
        }
        if (this.imagesToRestore.length > 0) {
            setTimeout(this.restoreImageAttributes, RESTORE_IMAGE_CALLBACK_TIMEOUT_LENGTH);
        }
    };
    return ImageCopyHandler;
}());
var imageCopyHandler;
export function handleImageCopy(target) {
    if (!imageCopyHandler) {
        imageCopyHandler = new ImageCopyHandler();
    }
    imageCopyHandler.handleCopy(target);
}
export function cleanupImageCopyHandler() {
    if (imageCopyHandler) {
        imageCopyHandler.dispose();
        imageCopyHandler = null;
    }
}
//# sourceMappingURL=ImageCopyHandler.js.map